import type { ReactNode } from "react";
import type { FormControlProps } from "@mui/material";
import {
  Checkbox,
  Chip,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";

interface TaillesInputProps extends FormControlProps {
  selectedTailles: Array<string>;
  setSelectedTailles: (t: Array<string>) => void;
  availableTailles: Array<string>;
}

function TaillesInput({
  selectedTailles,
  setSelectedTailles,
  availableTailles,
  ...formControlProps
}: Readonly<TaillesInputProps>): ReactNode {
  return (
    <FormControl fullWidth size="small" {...formControlProps}>
      <InputLabel>Taille(s)</InputLabel>
      <Select
        multiple
        value={selectedTailles}
        onChange={(event) => {
          setSelectedTailles(event.target.value as Array<string>);
        }}
        input={<OutlinedInput label="Taille(s)" />}
        renderValue={(selected) =>
          selected.map((s) => (
            <Chip key={s} label={s} size="small" sx={{ fontSize: "0.9em", mr: 0.5 }} />
          ))
        }>
        {(availableTailles ?? []).map((name) => (
          <MenuItem key={name} value={name}>
            <Checkbox checked={selectedTailles.includes(name)} sx={{ p: 0.5, mr: 1 }} />
            <ListItemText primary={name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default TaillesInput;
